<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="name">
					<el-input v-model="listQuery.name" placeholder="请输入门店名称" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="listQuery.type" placeholder="请选择门店类型" clearable @change="SearchData">
						<el-option v-for="item in dictionary['mdlx']" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="address">
					<el-input v-model="listQuery.address" placeholder="请输入门店地址" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="manager_name">
					<el-input v-model="listQuery.manager_name" placeholder="请输入经理姓名" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'Store.browse'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'Site.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<!--列开始-->
			<el-table-column type="selection"></el-table-column>
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="name" label="门店名称 "> </el-table-column>
			<el-table-column align="center" prop="default_img" label="门店默认展示图 ">
				<template slot-scope="scopes">
					<el-image style="width: 100px; height: 100px" :src="scopes.row.default_img"
						:preview-src-list="[scopes.row.default_img]">
					</el-image>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="type_name" label="门店类型"> </el-table-column>
			<el-table-column align="center" prop="open_status" label="是否营业" width="150">
				<template slot-scope="{ row }">
					<el-switch v-model="row.open_status" :active-value="1" :inactive-value="0" active-text="营业" inactive-text="休息"
						@change="changeState(row)" />
				</template>
			</el-table-column>
			<el-table-column align="center" prop="is_hot" label="是否推荐 ">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.is_hot == 1" type="success">推荐</el-tag>
					<el-tag v-else type="danger">不推荐</el-tag>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="address" label="门店地址 "> </el-table-column>
			<el-table-column align="center" prop="detail_address" label="详细地址 "> </el-table-column>
			<el-table-column align="center" prop="manager_name" label="经理姓名 "> </el-table-column>
			<!-- <el-table-column align="center" prop="manager_phone" label="经理电话 "> </el-table-column> -->
			<!-- <el-table-column align="center" prop="manager_qrcode" label="经理二维码 "> </el-table-column> -->
			<el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
			<el-table-column align="center" prop="" label="操作" width="200" class-name="action">
				<template slot-scope="scopes">
					<el-button v-auth="'Site.update'" icon="el-icon-edit" type="primary" size="mini"
						@click="HandleUpdate(scopes.row)">编辑</el-button>
					<el-button v-auth="'Site.delete'" icon="el-icon-delete" type="danger" size="mini"
						@click="RowDelete(scopes.row)">删除</el-button>
				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />

	</div>
</template>

<script>
	import api from '@/api/site/site' // 和数据交互相关写在api 方便复用
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	// import WangEditor from '@/components/WangEditor'
	// import FileList from '@/components/attachment/FileList'
	import dict_data from '@/api/system/dict_data'

	export default {
		name: 'Site',
		components: {
			Pagination
		},
		// 列绑定格式化器
		filters: {},
		mixins: [commonList],
		data() {
			return {
				// api接口方法
				api,
				dictionary: [],
				listQuery: {
					page: 1,
					limit: 10, // 页大小
					order: 'DESC', // 默认排序方式,
					sort: 'id',
					manager_name: '',
					name: '',
					address: '',
					type: ''
				}
			}
		},
		created() {
			this.loadData()
			dict_data
				.Drop({
					sort: 'sort',
					order: 'asc',
					isPaginator: false,
					dict_code: 'mdlx,'
				})
				.then((response) => {
					this.dictionary = response.data
				})
		},
		methods: {
			HandleCreate() {
				this.$router.push({
					path: '/site/edit'
				})
			},
			HandleUpdate(data) {
				this.$router.push({
					path: '/site/edit',
					query: {
						id: data.id
					}
				})
			},
			// 更新状态
			changeState(row) {
				api
					.ChangeStatus({
						id: row.id,
						open_status: row.open_status
					})
					.then((response) => {
						this.$notify({
							title: '成功',
							message: response.msg,
							type: 'success'
						})
					})
			}
		}
	}
</script>